import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function scrollToPricing() {
  const pricingElement = document.querySelector('#pricing')
  if (pricingElement) {
    const yOffset = -100 // Account for fixed header, matching Navbar offset
    const y = pricingElement.getBoundingClientRect().top + window.pageYOffset + yOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}
